













import { Component, Vue, Prop} from "vue-property-decorator";

@Component({})

export default class HandShakeFilledIcon extends Vue {
  /* Props */
  @Prop({ default: "#00C000" })
  public color!: string;
}
